import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { DocumentDataStore } from '../document-data/document-data.store';
import { PurchaseOrder } from './purchase-order.model';
import { IState, selectFeature } from './purchase-order-data.reducer';

@Injectable()
export class PurchaseOrderDataStore extends DocumentDataStore<
  IState,
  PurchaseOrder
> {
  constructor(store: Store<any>) {
    super(store, selectFeature);
  }
}
